import type { TradingFormState } from './trading-form.types';

type PositionManagementConfig = NonNullable<
  TradingFormState['positionManagementConfig']
>;
type ScaleInConfig = NonNullable<PositionManagementConfig['scaleIn']>;

export const createScaleInConfig = (
  overrides?: Partial<ScaleInConfig>
): ScaleInConfig => ({
  enabled: false,
  addSize: undefined,
  minPriceStepFromLastSignalPercent: undefined,
  onlyInProfit: true,
  ...overrides
});
